import React, { useEffect } from "react";
import { Container } from "./ServiceIntegrationTab.styles";
import GoogleSyncSection from "./GoogleSyncSection/GoogleSyncSection";
import { getMemberIntegration, TMemberIntegrationResponse } from "apis/member-integration";
import { getMemberAuthSyncSlack, TSlackSyncInfo } from "apis/messenger-auto-sync";
import SlackSyncSection from "./SlackSyncSection/SlackSyncSection";
import { AlarmChannel } from "apis/alarm-settings";
type ServiceIntegrationTabProps = {
  open: boolean;
};

const ServiceIntegrationTab: React.FC<ServiceIntegrationTabProps> = ({ open }) => {
  const [isGoogleSynced, setIsGoogleSynced] = React.useState(false);
  const [memberIntegrationInfo, setMemberIntegrationInfo] = React.useState<TMemberIntegrationResponse>();
  const [slackMemberAutoSyncInfo, setSlackMemberAutoSyncInfo] = React.useState<TSlackSyncInfo>();

  useEffect(() => {
    if (open) {
      onUpdateMemberIntegration();
      onUpdateSlackMessengerAutoSync();
    }
  }, [open]);

  const onUpdateMemberIntegration = async () => {
    //* INFO: 멤버 연동 정보를 조회하는 로직입니다.
    const res = await getMemberIntegration();
    if (res.success && res.data) {
      setMemberIntegrationInfo(res.data);
      setIsGoogleSynced(true);
    } else {
      setMemberIntegrationInfo(undefined);
      setIsGoogleSynced(false);
    }
  };

  const onUpdateSlackMessengerAutoSync = async () => {
    const res = await getMemberAuthSyncSlack();
    if (res) {
      setSlackMemberAutoSyncInfo(res);
    } else {
      setSlackMemberAutoSyncInfo(undefined);
    }
  };

  if (!open) return <></>;
  return (
    <Container>
      <GoogleSyncSection
        syncedId={memberIntegrationInfo?.id}
        isSynced={isGoogleSynced}
        syncedDomainList={memberIntegrationInfo?.domains}
        syncedOrgUnitList={memberIntegrationInfo?.orgUnits}
        onUpdateMemberIntegration={onUpdateMemberIntegration}
        syncedCreatedNum={memberIntegrationInfo?.syncedCreatedNum}
        syncedDeletedNum={memberIntegrationInfo?.syncedDeletedNum}
        lastSyncedDate={memberIntegrationInfo?.lastSyncedAt}
        integratedById={memberIntegrationInfo?.integratedById}
        integrationCategory={memberIntegrationInfo?.integrationCategory}
        alarmChannel={memberIntegrationInfo?.alarmChannel as AlarmChannel}
      />
      <SlackSyncSection
        isSynced={slackMemberAutoSyncInfo?.slackWorkspaceId ? true : false}
        syncedWorkspaceName={slackMemberAutoSyncInfo?.slackWorkspaceName ?? ""}
        onUpdateIntegration={onUpdateSlackMessengerAutoSync}
      />
    </Container>
  );
};

export default React.memo(ServiceIntegrationTab);
